<template>
  <div>
    <a-card :bordered="false" v-if="customerType">
      <div style="margin-bottom: 15px;">
        <a-input placeholder="输入问答模板标题" style="width:200px;margin-right:2%;" v-model="queryTemplate.title"/>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        <span style="position:absolute;right:20px;">
        <a-button type="primary" @click="settingModal">客服设置</a-button>
        <a-button class="add-question" @click="addModal">增加问答</a-button>
      </span>
      </div>
      <custom-page-table
        ref="table"
        :queryParams="queryTemplate"
        :columns="columnsTemplate"
        base-key="serviceUrl"
        params-path="respond/getTemplateList"
      >
      <span slot="action" slot-scope="rowItem">
        <a-button type="primary" size="small" @click="edit(rowItem.record.id)">编辑</a-button>
      </span>
      </custom-page-table>
      <a-modal title="客服设置" :footer="null" :visible="settingVisible" @cancel="handlesettingCancel" :width="400">
        <a-form-model layout="vertical">
          <a-form-model-item label="默认回复">
            <a-input
              v-model="ServiceSettingDto.servicesettingDefaultAnswer"
              placeholder="填写模板ID,多个以 , 号分开，最多10个"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="客服回复">
            <a-checkbox disabled v-model="ServiceSettingDto.servicesettingAnswerReplyType2">一级运营商可回复
            </a-checkbox>
            <a-checkbox v-model="ServiceSettingDto.servicesettingAnswerReplyType">二级运营商可回复</a-checkbox>
          </a-form-model-item>
          <a-form-model-item label="在线客服">
            <a-checkbox-group v-model="ServiceSettingDto.servicesettingShowPlaceType">
              <a-checkbox value="1">个人中心</a-checkbox>
              <a-checkbox value="2">商品详情</a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <div style="position: relative;left:288px">
            <a-button type="primary" @click="updateServiceSettingService()">保存</a-button>
          </div>
        </a-form-model>
      </a-modal>
      <a-modal
        :title="id == '' ? '增加问答' : '编辑问答'"
        :footer="null"
        :visible="addVisible"
        @cancel="handleAddCancel"
        :width="600"
      >
        <a-form-model layout="vertical">
          <a-form-model-item label="问答标题">
            <a-input v-model="title" placeholder="问答标题"></a-input>
          </a-form-model-item>
          <a-form-model-item label="问答内容">
            <a-textarea
              v-model="content"
              :autoSize="{ minRows: 4, maxRows: 4 }"
              :maxLength="500"
              @change="changeVal"
              placeholder="问答内容"
            ></a-textarea>
          </a-form-model-item>
          <a-form-model-item label="关键词触发">
            <a-input v-model="keyWord" placeholder="多个关键词以英文逗号隔开"></a-input>
          </a-form-model-item>
          <div style="position: relative;left:288px">
            <a-button type="primary" @click="addsave()">保存</a-button>
          </div>
        </a-form-model>
      </a-modal>
    </a-card>
    <SettingComponent :visible="typeVisible" @change="changeEvent" @submit="submitSetting"></SettingComponent>
  </div>
</template>

<script>
import SettingComponent from '@/views/service/serviceProvider/online/SettingComponent'

export default {
  name: '',
  data() {
    return {
      columnsTemplate: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '问答标题',
          dataIndex: 'title',
          width: '10%'
        },
        {
          title: '问答内容',
          dataIndex: 'content',
          width: '60%'
        },
        {
          title: '创建时间',
          dataIndex: 'time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryTemplate: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      settingVisible: false,
      addVisible: false,
      title: '',
      id: '',
      content: '',
      keyWord: '',
      txtVal: 0,
      ServiceSettingDto: {
        // 获取客服设置 默认数据
        servicesettingAnswerReplyType: false, //客服回复类型（1，一级可回复，2,2级可回复） ,
        servicesettingAnswerReplyType2: true, //客服回复类型（1，一级可回复，2,2级可回复） ,
        servicesettingDefaultAnswer: '', // 默认回答模板id，用逗号分隔 ,
        servicesettingId: '', // id ,
        servicesettingIsCanReplyTrans: false, // 二分是否可以转一级（1可以，0不可以） ,
        servicesettingShowPlaceType: [] //显示位置（1，个人中心，2商品详情页，多个以逗号分隔）
      },
      typeVisible: false,
      customerType: 0
    }
  },
  components: {
    SettingComponent
  },
  created() {
    this.queryTemplate = {
      respondMerchantId: this.merchantId,
      respondPlatformId: this.platformId,
      title: ''
    }
  },
  mounted() {
    this.getServiceSettingService()
  },
  methods: {
    submitSetting() {
      this.getServiceSettingService()
    },
    changeEvent(e) {
      this.typeVisible = e
    },
    edit(id) {
      // ‘打开弹窗’
      this.addVisible = true
      this.id = id
      this.dateiles(id)
      this.getLogUtils().logWithTag('id ====================', id)
    },
    dateiles(id) {
      // '详情信息'
      let url = 'respond/getTemplate/' + this.platformId + '/' + this.merchantId + '/' + id
      this.getHttpServices()
        .getServerApiService()
        .post(url)
        .then(res => {
          this.title = res.title
          this.content = res.content
          this.keyWord = res.keyWord
        })
        .catch(err => {
          this.getLogUtils().logWithTag('========err=========', err)
          this.$message.error(err)
        })
    },
    // 保存客服设置
    updateServiceSettingService() {
      this.setdialogVisible = false
      var data = new Object()
      data.servicesettingAnswerReplyType = this.ServiceSettingDto.servicesettingAnswerReplyType ? 2 : ''
      data.servicesettingDefaultAnswer = this.ServiceSettingDto.servicesettingDefaultAnswer
      data.servicesettingId = this.ServiceSettingDto.servicesettingId
      if (this.ServiceSettingDto.servicesettingIsCanReplyTrans) {
        data.servicesettingIsCanReplyTrans = 1
      } else {
        data.servicesettingIsCanReplyTrans = 0
      }
      data.servicesettingMerchantId = this.merchantId
      data.servicesettingPlatformId = this.platformId
      var servicesettingShowPlaceType = ''
      for (var i = 0; i < this.ServiceSettingDto.servicesettingShowPlaceType.length; i++) {
        servicesettingShowPlaceType += this.ServiceSettingDto.servicesettingShowPlaceType[i] + ','
      }
      data.servicesettingShowPlaceType = servicesettingShowPlaceType.substring(
        0,
        servicesettingShowPlaceType.length - 1
      )
      this.getHttpServices()
        .getServerApiService()
        .post('service/updateServiceSettingService', data)
        .then(res => {
          this.$message.success('设置成功')
        })
        .catch(err => {
          this.$message.error('设置失败')
        })
    },
    getServiceSettingService() {
      // '获取客服设置 默认数据'
      var data = new Object()
      data.servicesettingMerchantId = this.merchantId
      data.servicesettingPlatformId = this.platformId
      this.getHttpServices()
        .getServerApiService()
        .post('service/getServiceSettingService', data)
        .then(res => {
          this.customerType = res.customerType
          this.ServiceSettingDto.servicesettingId = res.servicesettingId
          this.ServiceSettingDto.servicesettingAnswerReplyType = res.servicesettingAnswerReplyType == 2 ? true : false
          if (res.servicesettingIsCanReplyTrans == 1) {
            this.ServiceSettingDto.servicesettingIsCanReplyTrans = true
          } else {
            this.ServiceSettingDto.servicesettingIsCanReplyTrans = false
          }
          var len = res.servicesettingShowPlaceType ? res.servicesettingShowPlaceType.split(',') : ''
          for (var i = 0; i < len.length; i++) {
            if (len[i]) {
              this.ServiceSettingDto.servicesettingShowPlaceType.push(len[i])
            }
          }
          this.ServiceSettingDto.servicesettingDefaultAnswer = res.servicesettingDefaultAnswer
        })
        .catch(err => {
          this.getLogUtils().errorWithTag('========getServiceSettingService=========', err)
        })
    },
    handlesettingCancel() {
      this.settingVisible = false
    },
    handleAddCancel() {
      this.addVisible = false
    },
    //新增问答
    addsave() {
      this.addVisible = false
      var data = new Object()
      data.title = this.title
      data.content = this.content
      data.keyWord = this.keyWord
      data.respondMerchantId = this.merchantId
      data.respondPlatformId = this.platformId
      if (this.id !== '') {
        data.id = this.id
      }
      var respondTemplateDto = data
      this.getHttpServices()
        .getServerApiService()
        .post('respond/saveTemplate', respondTemplateDto)
        .then(res => {
          if (!this.id) {
            this.$message.success('新增成功')
          } else {
            this.$message.success('编辑成功')
          }
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.showNetWorkErrorMessage(err)
        })
    },
    addModal() {
      this.title = ''
      this.keyWord = ''
      this.id = ''
      this.content = ''
      this.addVisible = true
    },
    settingModal() {
      this.settingVisible = true
    },
    changeVal() {
      this.txtVal = this.content.length
    }
  }
}
</script>
<style lang="less" scoped>
.add-question {
  margin-left: 15px;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
</style>
